import {
  isMagicLinkMfaChallenge,
  resolveNotificationDeepLink,
  type MagicLinkMfaBootstrap,
  type NotificationDeepLinkParams,
} from '@/utils/notificationDeepLink';

import type { AuthTokenResponse } from '@/api/user';
import type { User } from '@/types/user';

export type NotificationMagicLinkRedeemResult =
  | { kind: 'mfa'; bootstrap: MagicLinkMfaBootstrap }
  | {
      kind: 'authenticated';
      user: User;
      accessToken: string;
      nextPath: string;
    };

/**
 * Map a magic-link login API response to the next email deep-link action.
 * Email `/notifications?magic_link=` always redeems; this only interprets the result.
 */
export function resolveNotificationMagicLinkRedeemResult(
  res: AuthTokenResponse,
  deepLinkParams: NotificationDeepLinkParams,
): NotificationMagicLinkRedeemResult {
  if (isMagicLinkMfaChallenge(res) && res.mfa_token) {
    return {
      kind: 'mfa',
      bootstrap: {
        mfaToken: res.mfa_token,
        mfaMethod: res.mfa_method,
        mfaSelectionRequired: Boolean(res.mfa_selection_required),
        userEmail: res.user_email,
        nextPath: resolveNotificationDeepLink(res.user?.role, deepLinkParams),
      },
    };
  }

  const user = res.user;
  const accessToken = res.access_token;
  if (!user || !accessToken) {
    throw new Error('Invalid magic link response');
  }

  return {
    kind: 'authenticated',
    user,
    accessToken,
    nextPath: resolveNotificationDeepLink(user.role, deepLinkParams),
  };
}
